import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header = () => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    if (window.confirm('¿Estás seguro que deseas cerrar sesión?')) {
      logout();
    }
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="header-title">Vortex Dashboard</h1>
        </div>
        
        <div className="header-right">
          <div className="user-info">
            <span className="user-icon">👤</span>
            <span className="username">{user?.username}</span>
            <span className="user-role">({user?.role})</span>
          </div>
          
          <button 
            onClick={handleLogout}
            className="logout-button"
            title="Cerrar sesión"
          >
            <span className="logout-icon">🚪</span>
            Salir
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;